import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddProgramUser.module.scss";
import { CloseIcon } from "Assets/icons";
import { useLazyClientLookupSearchQuery } from "store/services/utility";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast, userFullName } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useAddProgramUserMutation, useUpdateChatterProgramMutation } from "store/services/chatter/program";
import { debounce } from "lodash";

const AddProgramUserPop = ({ show, setShow, programId }) => {

    const handlePopup = () => {

        setShow(!show);
    };

    const [selectedUsers, setSelectedUsers] = useState([]);
    const [validation, setValidation] = useState(null)
    const [usersList, setUsersList] = useState([]);
    const [filter, setFilter] = useState({ search: "", client: "chatter" })

    const [getUsersListQuery, { isLoading: getUserLoading, isFetching: getUserFetching }] = useLazyClientLookupSearchQuery();
    const [addProgramMembers, { isLoading: addProgramMembersLoading }] = useAddProgramUserMutation();

    const handleCheck = (checked, id) => {

        let list = [...selectedUsers];

        if (checked) {

            list.push(id);
            validation && setValidation(null);
        }
        else {

            const index = list.indexOf(id);
            if (index > -1) {
                delete list[index];
            };
        };

        setSelectedUsers(list.filter(Boolean));
    };

    const handleSubmit = async () => {

        try {

            setShow(!show);
            setSelectedUsers([]);
            setFilter({ search: "", client: "chatter" })
            setUsersList([]);
            
            const result = await addProgramMembers({ programId, data: { members_id: selectedUsers } });
            if (result?.error) return console.error("Error adding user", result.error);


            successMessageToast(result?.data?.message);

        } catch (err) { console.error("Error adding user", err); }
    };

    const getUsers = async () => {

        try {

            const result = await getUsersListQuery(filter);
            if (result?.error) return console.error("Error searching client", result.error);

            setUsersList(result?.data);
        } catch (err) { console.error("Error searching client", err); }
    };

    const handleFilterChange = (key) => (value) => {
        setFilter({
            ...filter,
            [key]: value
        })
    };

    const handleSearch = useCallback(debounce((event) => {

        handleFilterChange("search")(event?.target?.value);
    }, 500), [handleFilterChange, 500]);

    useEffect(() => {

        if (filter?.search) getUsers();
    }, [filter])

    return (
        <>
            {addProgramMembersLoading ? <LoadingOverlay /> : null}
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h4 className="m-0 fw-bold themeBlue">Add Member</h4>

                    </div>
                    <Row className="mt-4">
                        <Col className="col-12 my-2">
                            <Row>
                                <Col lg="6" sm="12" className="d-flex align-items-center">
                                    <label
                                        className="form-label themeBlue fw-bold m-0 p-0"
                                        style={{ fontSize: "18px" }}
                                    >
                                        Chatter Client
                                    </label>
                                    <Button
                                        variant="transparent"
                                        style={{ border: "none",marginTop:"-3px" }}
                                        onClick={() => handleFilterChange("client")("chatter")}
                                    >
                                        {
                                            filter?.client == "chatter" ? selectedCheckBox : notSelectedCheckBox
                                        }
                                    </Button>
                                </Col>
                                <Col lg="6" sm="12" className="d-flex align-items-center">
                                    <label
                                        className="form-label themeBlue fw-bold m-0 p-0"
                                        style={{ fontSize: "18px" }}
                                    >
                                        Chatter Peer
                                    </label>
                                    <Button
                                        variant="transparent"
                                        style={{ border: "none",marginTop:"-2px" }}
                                        onClick={() => handleFilterChange("client")("peer")}
                                    >
                                        {
                                            filter?.client == "peer" ? selectedCheckBox : notSelectedCheckBox
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col className="col-12 my-2">
                            <div className="iconWithText position-relative">
                                <span className="icn position-absolute" style={{ right: 10 }}>
                                    {searchIcn}
                                </span>
                                <input
                                    type="text"
                                    style={{ paddingRight: 30 }}
                                    placeholder="Search"
                                    className={`${styles.formControl} form-control`}
                                    onChange={handleSearch}
                                    disabled={addProgramMembersLoading}
                                />
                            </div>
                        </Col>
                        <Col lg="12" className="my-2">
                            {
                                getUserLoading || getUserFetching ? <LoadingIndicator /> : (
                                    <ul className="list-unstyled ps-0 mb-0">
                                        {
                                            usersList?.map((item, index) => {
                                                return (
                                                    <li className="py-2" key={index}>
                                                        <div className="d-flex align-items-center justify-content-between gap-10">
                                                            <div className="left d-flex align-items-center gap-10">
                                                                <div className="content">
                                                                    <h6 className="m-0 fw-bold themeBlue text-capitalize">{userFullName(item)}</h6>
                                                                </div>
                                                            </div>
                                                            <div className="right">
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ height: 20, width: 20 }}
                                                                    className="form-check"
                                                                    checked={selectedUsers.includes(item.id)}
                                                                    onChange={e => handleCheck(e.target.checked, item.id)}
                                                                    disabled={addProgramMembersLoading}
                                                                />
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                )
                            }
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center flex-column">
                    <Button
                        type="submit"
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                        onClick={handleSubmit}
                        disabled={addProgramMembersLoading}
                    >
                        Save

                    </Button>
                    {validation ? <div className="error">{validation}</div> : null}
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default AddProgramUserPop;



const searchIcn = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38144 0.235352 8.05579 0.235352 6.48936C0.235352 4.92308 0.777789 3.59697 1.86266 2.51103C2.94754 1.42524 4.27319 0.882339 5.83962 0.882339C7.4059 0.882339 8.73201 1.42493 9.81796 2.51011C10.9037 3.59529 11.4466 4.92125 11.4466 6.48799C11.4466 7.14264 11.3368 7.76788 11.1171 8.36372C10.8973 8.95955 10.604 9.47777 10.2373 9.91838L15.228 14.6076L14.2621 15.5737ZM5.841 10.7189C7.02212 10.7189 8.02251 10.309 8.84216 9.48915C9.66197 8.6695 10.0719 7.66911 10.0719 6.48799C10.0719 5.30686 9.66197 4.30647 8.84216 3.48682C8.02251 2.66701 7.02212 2.25711 5.841 2.25711C4.65987 2.25711 3.65948 2.66701 2.83983 3.48682C2.02003 4.30647 1.61012 5.30686 1.61012 6.48799C1.61012 7.66911 2.02003 8.6695 2.83983 9.48915C3.65948 10.309 4.65987 10.7189 5.841 10.7189Z" fill="#1C1B1F" />
</svg>

const notSelectedCheckBox = <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_5342_36802" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5342_36802)">
        <path d="M12 21C10.7468 21 9.58226 20.763 8.49619 20.2943C7.39072 19.8173 6.43908 19.1749 5.63211 18.3679C4.82514 17.5609 4.18269 16.6093 3.70567 15.5038C3.23702 14.4177 3 13.2532 3 12C3 10.7468 3.23702 9.58226 3.70567 8.49619C4.18269 7.39072 4.82514 6.43908 5.63211 5.63211C6.43908 4.82514 7.39072 4.18269 8.49619 3.70567C9.58226 3.23702 10.7468 3 12 3C13.2532 3 14.4177 3.23702 15.5038 3.70567C16.6093 4.18269 17.5609 4.82514 18.3679 5.63211C19.1749 6.43908 19.8173 7.39072 20.2943 8.49619C20.763 9.58226 21 10.7468 21 12C21 13.2532 20.763 14.4177 20.2943 15.5038C19.8173 16.6093 19.1749 17.5609 18.3679 18.3679C17.5609 19.1749 16.6093 19.8173 15.5038 20.2943C14.4177 20.763 13.2532 21 12 21Z" fill="#ECECEC" stroke="#16BF12" stroke-width="2" />
    </g>
</svg>

const selectedCheckBox = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
>
    <path
        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
        fill="#16BF12"
    />
</svg> 